import React, { useState } from "react";
import PropTypes from "prop-types";
import { Column, Field, Control, Label } from "rbx";
import { BooleanInput } from "../../../components/inputs";
import {
  SystemCodeCodeNameSelect,
  SystemCodeCategorySelect
} from "../../../components/SystemCodes";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  Active: true,
  Type: "User",
  OR: [
    {
      Category: "Fleet"
    },
    {
      CodeName: "InspectionCd"
    }
  ]
};

function SystemCodeFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const handleClose = () => onClose(onFilter(inputs));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));
  const handleCancel = () => onClose(onFilter(filters));

  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column size={5}>
          <Control>
            <Label>Category</Label>
            <SystemCodeCategorySelect
              required
              icon="globe"
              label="Select..."
              name="Category"
              orderByMulti={["Category_ASC"]}
              value={inputs.Category}
              where={{ Category_in: ["Fleet", "Inventory"] }}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column size={5}>
          <Field>
            <Control>
              <Label>Code Name</Label>
              <SystemCodeCodeNameSelect
                required
                category={inputs.Category}
                icon="globe"
                label="Select..."
                name="CodeName"
                orderByMulti={["CodeName_ASC"]}
                value={inputs.CodeName}
                where={
                  inputs.Category === "Inventory"
                    ? { Category: inputs.Category, CodeName: "InspectionCd" }
                    : { Category: inputs.Category }
                }
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
SystemCodeFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default SystemCodeFilters;
